<mat-card>{{'services' | translate}}</mat-card>


<div class="container" style="padding: 25px;">

    <mat-grid-list cols="6" rowHeight="50px">


        <mat-grid-tile colspan="3">
            <form class="example-form">
                <mat-form-field appearance="standard" class="example-full-width">
                    <mat-label>{{'selectCategory' | translate}}</mat-label>
                    <input type="text" matInput [formControl]="searchCategory" required [matAutocomplete]="auto">
                    <button mat-button matSuffix mat-icon-button>
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </button>
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectCatChange($event.option.value)"
                        [displayWith]="displayFn">
                        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                            {{language == 1 ? option.aDesc : option.eDesc}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </form>
        </mat-grid-tile>

        <mat-grid-tile colspan="3">
            <form class="example-form">
                <mat-form-field appearance="standard" class="example-full-width">
                    <mat-label>{{'selectBiller' | translate}}</mat-label>
                    <input type="text" matInput [formControl]="searchBillersList" required [matAutocomplete]="auto1">
                    <button mat-button matSuffix mat-icon-button>
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </button>
                    <mat-autocomplete #auto1="matAutocomplete"
                        (optionSelected)="selectBillerChange($event.option.value)" [displayWith]="displayFnBillerList">
                        <mat-option *ngFor="let option of filteredOptionsBillersList | async" [value]="option">
                            {{language == 1 ? option.aDesc : option.eDesc}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </form>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard">
                <mat-label>{{'subCategoryStatus' | translate}}</mat-label>
                <mat-select [(value)]="selectedStatus" (selectionChange)="selectStatusChange()"
                    [disabled]="selectedCategory == null">
                    <mat-option *ngFor="let status of subCatgstatus" [value]="status.id">
                        {{status.name | translate}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard">
                <mat-label>{{'filter' | translate}}</mat-label>
                <input matInput (keyup)="applyFilter($event)" [disabled]="selectedCategory == null"
                    placeholder="Ex. Mia" #input>
            </mat-form-field>
        </mat-grid-tile>

    </mat-grid-list>

    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort>

            <!-- ID Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'id' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
            </ng-container>

            <!-- Progress Column -->
            <ng-container matColumnDef="arabicName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'arabicName' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.aDesc}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="englishName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'englishName' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.eDesc}} </td>
            </ng-container>


            <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef> {{'edit' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button (click)="edit(row.id)">
                        <mat-icon>edit</mat-icon>
                    </button>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}} "{{input.value}}"</td>
            </tr>
        </table>

        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

</div>

<app-matspinner [overlay]="spinnerOverlay"></app-matspinner>